module.exports = __webpack_public_path__ + "img/bghe4.0ec1e08f.png";